export enum PaperSize {
  A4 = 0,
  Letter = 1
}
